import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './TemplateComponent.module.scss';

const TemplateComponent = ({ foo }) => <div className={classNames(s.foo)}>{foo}</div>;

TemplateComponent.propTypes = { foo: PropTypes.string };

TemplateComponent.defaultProps = { foo: 'I am TemplateComponent' };

export default TemplateComponent;
